/*
 * author kcz
 * date 2019-11-20
 */
import OrginItemWord from "./index.vue";

OrginItemWord.install = function(Vue) {
  Vue.component(OrginItemWord.name, OrginItemWord);
};

export default OrginItemWord;
